<template>
  <div class="sign-view">
    <router-view />
  </div>
</template>

<script>

export default {
  name: 'home',
  data () {
    return {}
  }
}
</script>
<style scoped lang="scss">
.sign-view {
  width: 100%;
  height: 100vh;
}
</style>
